var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBvt = function SvgBvt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  })));
};
export { SvgBvt as ReactComponent };